// @flow

import { Input } from '@chakra-ui/react'

function Search () {
  return <Input placeholder='Enter scene ID' />
}

export default Search
